<template>
  <section class="legal">
    <section class="tab">
      <div :class="tabActive === 'copyright' && 'active'" @click="tabActive = 'copyright'">{{ t('copyright') }}</div>
      <div :class="tabActive === 'privacy' && 'active'" @click="tabActive = 'privacy'">{{ t('privacy') }}</div>
      <div :class="tabActive === 'children' && 'active'" @click="tabActive = 'children'">{{ t('children') }}</div>
      <div :class="tabActive === 'user' && 'active'" @click="tabActive = 'user'">{{ t('userAgreement') }}</div>
    </section>
    <div v-if="tabActive == 'copyright'">
      <!-- 海外版权声明 -->
      <section v-if="isOverseas" class="content">
        <div class="head">Joltrix Product Copyright Statement</div>
        <p>To protect intellectual property achievements, Joltrix (hereinafter referred to as "this Platform")
          hereby issues this statement regarding its product copyrights in accordance with the "Copyright Law
          of the People's Republic of China" and other relevant laws and regulations:</p>
        <div class="title">I. Ownership of Rights </div>
        <p>The copyright, patent rights, trademark rights, and other intellectual property rights of all content
          contained in all products under this Platform (including but not limited to websites, application
          products, etc.) are owned by Joltrix.</p>
        <p>This includes, but is not limited to, all written works, artistic designs, software codes,
          audiovisual content, and interface designs.</p>
        <div class="title">II. Usage Restrictions Without the written authorization of this Platform, no
          entity or individual may perform the following acts:</div>
        <p>Illegally disseminate the content of this Platform through reproduction, mirroring, deep linking, or
          other means.</p>
        <p>Unauthorized copying, use, modification, adaptation, translation, or compilation of the content of
          this Platform.</p>
        <p>Cracking, decompiling, reverse engineering, or other acts that infringe upon the software copyright
          of this Platform.</p>
        <p>Illegally crawling or scraping the data resources of this Platform through technical means such as
          crawlers.</p>
        <p>Other acts that infringe upon the intellectual property rights of this Platform.</p>
        <div class="title">III. Infringement Liability </div>
        <p>For any act that infringes upon the copyright and related intellectual property rights of Joltrix
          products, Joltrix reserves the right to pursue legal liability in accordance with the law.
          Joltrix will take necessary legal actions to safeguard its legitimate rights and interests.</p>

        <div class="title">IV. Validity of the Statement </div>
        <p>This statement is a dynamically updated document, and updated versions shall automatically take
          effect from the date of publication.</p>
        <p>The right of final interpretation belongs to Joltrix.</p>
      </section>
      <!-- 版权声明 -->
      <section v-else class="content">
        <div class="head">
          跃次元产品版权声明
        </div>
        <p>为保护知识产权成果，跃次元（以下亦称"本平台"）根据《中华人民共和国著作权法》等相关法律法规，就本平台产品版权声明如下：</p>

        <div class="title">一、版权归属</div>
        <p>
          本平台旗下所有产品（包括但不限于网站、应用程序产品等）所包含的所有文字作品、美术设计、软件代码、视听内容、界面设计等内容，其著作权、专利权、商标权及其他知识产权均归属于跃次元所有。</p>

        <div class="title">二、使用限制</div>
        <p>未经本平台书面授权，任何单位或个人不得实施下列行为：</p>
        <p>1、通过转载、镜像、深度链接等方式非法传播本平台内容；</p>
        <p>2、擅自复制、使用、修改、改编、翻译、汇编本平台内容；</p>
        <p>3、破解、反编译、反向工程等侵害本平台软件著作权的行为；</p>
        <p>4、利用爬虫等技术手段非法抓取本平台数据资源；</p>
        <p>5、其他侵害本平台知识产权的行为。</p>

        <div class="title">三、侵权责任</div>
        <p>对于任何侵犯跃次元产品版权及相关知识产权的行为，跃次元将保留依法追究其法律责任的权利，并采取必要的法律行动以维护自身合法权益。</p>

        <div class="title">四、声明效力</div>
        <p>本声明为动态更新文件，更新版本自发布之日起自动生效，最终解释权归跃次元所有。</p>
      </section>
    </div>
    <div v-if="tabActive == 'privacy'">
      <section v-if="isOverseas" class="content">
        <div class="head bold">PRIVACY POLICY</div>
        <p class="bold">Last Updated: [01/09/2026]</p>
        <p>This Policy applies to the products and services (also referred to as "the Services") developed, maintained,
          and operated by Fuzhou Yueciyuan Network Technology Co., Ltd. (hereinafter referred to as "Yueciyuan" or
          "we").</p>
        <p>When you use our Services, we may collect and use your relevant information. We hope to explain through this
          Privacy Policy (hereinafter referred to as "this Policy") how we collect, use, store, and share this
          information when you use our Services, as well as the ways we provide you to access, update, control, and
          protect this information. This Policy is closely related to the use of our Services. We hope you read it
          carefully and make choices you deem appropriate in accordance with the guidance of this Policy when necessary.
          We will try to express the relevant technical terms in this Policy as concisely as possible for your
          understanding.</p>
        <p class="bold">Special Notice: Users under the age of 14 are subject to both this Policy and the Children's
          Personal Information Protection Guidelines. If there is any inconsistency between specific provisions and the
          provisions of this Policy, the specific provisions shall prevail.</p>
        <p class="bold">If you are a minor under the age of 18, you need to read the terms of this Policy
          in the company of your guardian. Please make sure that you and your guardian read it carefully; please use our
          products and services only after obtaining your guardian's consent to all the terms of this Policy.</p>
        <p class="bold">Special Notice to Guardians: Please help us protect the personal information and
          privacy of the minor under your guardianship. Require them to read and accept this Policy together under your
          supervision, and submit personal information and use our services only with your consent and guidance. If you
          do not agree with the contents of this Policy, you should require the minor under your guardianship to
          immediately stop accessing/using our services.</p>
        <div class="title">Article 1 Definitions and Explanations</div>
        <p>1. Personal Information: refers to all kinds of information recorded electronically or by other means that
          are related to an identified or identifiable natural person, excluding information after anonymization.</p>
        <p>2. Sensitive Personal Information: refers to personal information that, once leaked or illegally used, may
          easily lead to infringement of a natural person's personal dignity or endangerment of their personal or
          property safety, including biometric information, religious beliefs, specific identity, medical health,
          financial accounts, location tracking, and other information, as well as the personal information of minors
          under the age of fourteen.</p>
        <p>3. De-identification/Anonymization: refers to the process of technically processing personal information such
          that the subject of the personal information cannot be identified and the processed information cannot be
          restored. Information obtained after de-identification of personal information does not constitute personal
          information.</p>
        <div class="title">Article 2 How We Collect and Use Your Personal Information</div>
        <p>When providing services, we may collect, store, and use the following information related to you. Based on
          the principles of legality, legitimacy, and necessity, we only collect and use information necessary to
          implement product functions.</p>
        <p class="bold">(1) Information you actively provide when using our products and services:</p>
        <p>1. The mobile phone number you provide to us when you register and log in to your account to use the products
          and services. We will verify your identity via SMS verification codes to help you register and log in to your
          account;</p>
        <p>2. To fulfill the legal obligation of real-name registration for online games, implement anti-addiction
          protection requirements for minors, and ensure the security of your game account, when you register or log in
          to our game product services, we require you to provide your name and ID number to verify your real identity.
          To achieve the purpose of real-name authentication, you agree and authorize us to provide, query, and verify
          the aforementioned identity information with relevant real-name authentication authorities (the national
          online game regulatory authority, the Ministry of Public Security, or other entrusted/cooperating
          institutions). If you do not provide real identity information or provide false information, you will be
          unable to log in, enjoy relevant services, or will be subject to corresponding restrictions during game use.
        </p>
        <p class="bold">You undertake to provide true, lawful, accurate, and valid real-name registration information,
          and shall not register under another person's identity information.</p>
        <p>3. Information you submit through our customer service or when participating in activities we organize</p>
        <p>For example, the questionnaire you fill out when participating in our online activities may contain
          information such as your gender, age, grade, etc. This information is used for statistical analysis and to
          adjust and optimize products and services. We will de-identify such information upon collection, and the
          processed data cannot be directly associated with your personal identity.</p>
        <p class="bold">(2) Providing Basic Product Functions and Services</p>
        <p>1. To identify different device types and ensure product interface adaptation and functional compatibility,
          we collect device-related information: device brand, device model, software system version, and screen
          resolution.</p>
        <p>2. To achieve server region selection and content localization, we also obtain SIM card status, obtain
          carrier information_SIM, obtain carrier information_NETWORK, obtain SIM card country code, device language,
          and device region information, which are used to automatically match the corresponding server.</p>
        <p>3. To identify account login status, manage multi-device login, perform data statistics, conduct gray
          testing, and diagnose faults, we also collect device identifier information such as Android ID and OAID when
          necessary.</p>
        <p>4. Obtain Wi-Fi parameters, read Wi-Fi status, obtain mobile network type, and obtain network status. When
          you initiate a network request or download task, we may collect and obtain this information and these
          permissions to determine whether the current network environment is available.</p>
        <p>5. To ensure that you can timely obtain the latest product version and security patches, in the process of
          detecting whether an update is needed and downloading and installing the update package, we need to collect
          your application version, application package name, application name, application foreground/background
          status, and application list information.</p>
        <p>6. When your device configuration supports it, to achieve animation display effects for in-app scene visuals,
          provide auxiliary positioning, and quickly adjust the game perspective based on mobile device posture, we
          collect your device's accelerometer sensor and gyroscope sensor information. Please understand that standalone
          device sensor data does not involve any personal location information and cannot be combined with other
          information to identify a specific natural person.</p>
        <p>7. When you use our products and services, we collect crash and error log information and network log
          information for fault diagnosis and system anomaly localization, to resolve issues you encounter during use.
          This information is anonymized and will not be directly associated with your personal identity.</p>
        <p>8. For statistical analysis of operational data, we have integrated third-party data analysis and statistics
          SDKs. During your use of product services, these third-party SDKs may collect and process GAID information.
        </p>
        <p class="bold">(3) Access to System Permissions</p>
        <p>You understand and agree that, in the process of using this Service, we will apply for access to your system
          permissions when necessary to implement the product functions supported by these permissions.</p>
        <p>1、When you upload photos/images/videos in the in-app customer service scenario, we will access the device
          photo album permission to enable the function of providing proof through communication with customer service.
        </p>
        <p>2、To provide you with timely updates on products and services, we will obtain your message push permission to
          push activity notifications and progress to you. You can choose to turn off message push in your device
          settings. After turning it off, you will not receive in-app message push, but this will not affect your use of
          other functions.</p>
        <p class="bold">(4) Order Payment Services</p>
        <p>You can obtain virtual products related to our products and/or services by paying us, including but not
          limited to game currency and game items. Please note that the payment function is provided to you by
          third-party payment institutions cooperating with us. Third-party payment institutions may need to collect
          information necessary for the payment function. We will not obtain payment account or password information
          related to your payment. After you successfully pay, we will only obtain from the third-party payment
          institution the result verification information that you have completed payment, and then provide you with the
          corresponding virtual products. If you wish to learn about the specific rules for third-party payment
          institutions collecting personal information, please refer to the privacy policy of the third-party payment
          institution you choose.</p>
        <p>To display your account transaction information and ensure transaction security, we collect information
          generated during your use of our products and/or services (including information on the goods or services you
          purchased, specific order number, order creation time, and transaction amount) for display and to facilitate
          your order management.</p>
        <p class="bold">(5) Exceptions to Obtaining Consent</p>
        <p>In accordance with relevant laws and regulations, in the following circumstances, collecting your information
          does not require obtaining your authorization or consent:</p>
        <p>(1) Related to national security or national defense security;</p>
        <p>(2) Related to public security, public health, or major public interests;</p>
        <p>(3) Related to criminal investigation, prosecution, trial, and judgment execution, etc.;</p>
        <p>(4) Related to protecting the life, property, or other major lawful rights and interests of the information
          subject or other individuals, but it is difficult to obtain your own consent;</p>
        <p>(5) The collected information is information you voluntarily disclose to the public;</p>
        <p>(6) Collecting information from legally disclosed information sources, such as lawful news reporting and
          government information disclosure channels;</p>
        <p>(7) Necessary for signing a contract at your request;</p>
        <p>(8) Necessary for maintaining the secure and stable operation of our services, such as detecting and
          resolving product or service failures;</p>
        <p>(9) Necessary for lawful news reporting;</p>
        <p>(10) Necessary for academic research institutions to conduct statistics or academic research based on public
          interests, and when providing the results of academic research or descriptions externally, the information
          contained in the results is de-identified;</p>
        <p>(11) Other circumstances provided by laws and regulations.</p>
        <div class="title">Article 2 Information We May Share, Transfer, or Disclose</div>
        <p class="bold">(1) Sharing</p>
        <p>Except in the following circumstances, we will not share your personal information with any third party
          without your consent:</p>
        <p>1. Sharing with explicit consent: After obtaining your explicit consent, we will share your personal
          information with other parties.</p>
        <p>2. We may share your personal information externally in accordance with the provisions of laws and
          regulations or in accordance with mandatory requirements of government authorities.</p>
        <p>3. Sharing with our affiliates: Your personal information may be shared with our affiliates. We will only
          share necessary personal information in accordance with the principle of minimum necessity, and it is bound by
          the purposes stated in this Policy. If an affiliate intends to change the purpose of processing personal
          information, it will re-obtain your authorization and consent.</p>
        <p class="bold">(2) Transfer</p>
        <p>1. As our business continues to develop, we may undergo mergers, acquisitions, asset transfers, or similar
          transactions, and your information may be transferred as part of such transactions. We will require the new
          company or organization holding your information to continue to be bound by this Privacy Policy; otherwise, we
          will require such company or organization to re-obtain your authorization and consent.
        </p>
        <p>2. After obtaining your explicit consent, we will transfer your information to other parties.</p>
        <p class="bold">(3) Disclosure</p>
        <p>We or our affiliates will only disclose your information under the following circumstances and on the premise
          of adopting security protection measures that comply with industry standards:</p>
        <p>1. At your request, disclose the information you specify in the manner of disclosure you explicitly consent
          to;</p>
        <p>2. Disclosure based on law: In the case of laws, legal proceedings, litigation, or mandatory requirements of
          government authorities, we may publicly disclose your personal information.</p>
        <p>3. Reasonably necessary for complying with applicable laws and regulations, safeguarding public interests, or
          protecting the personal and property safety or lawful rights and interests of our customers, us, our
          affiliates, other users, or employees.</p>
        <div class="title">Article 3 About Cookies</div>
        <p class="bold">(1) What Are Cookies</p>
        <p>When you use our products, we set or retrieve small data files called cookies on your computer or mobile
          device. When you log in to your account, with the help of cookies, we can identify whether you are our user
          each time you use our products; it also enables direct navigation from one page to another without having to
          log in again on each page. Web beacons, pixels, or other similar files can do the same thing. In this Policy,
          we use the term "Cookies" to refer to all files that collect information in this manner.</p>
        <p class="bold">(2) How We Use Cookies</p>
        <p>We use Cookies to determine whether you are already logged in without requiring you to log in again on each
          page, record the pages you have browsed so that you can browse more quickly and conveniently next time, and
          improve service quality and optimize user experience. We also use Cookies to enable support for security
          features, monitor and prevent suspicious activity, fraudulent traffic, and violations of our user agreement.
          We will not use Cookies for any purpose other than those stated in this Policy.</p>
        <p class="bold">(3) Accepting or Refusing Cookies</p>
        <p>You have the right to choose to accept or refuse Cookies. You can refuse Cookies by modifying your browser
          settings or configuring your mobile device. However, if you choose to refuse Cookies, you may be unable to log
          in or use services that depend on Cookies.</p>
        <div class="title">Article 4 How We Retain, Store, and Protect Information</div>
        <p>1. We have used security measures that comply with industry standards to protect the personal information you
          provide, preventing unauthorized access, public disclosure, use, modification, damage, or loss of data. We
          will take all reasonable and practicable measures to protect your personal information.</p>
        <p>2. We will take all reasonable and practicable measures to ensure that we do not collect irrelevant personal
          information. We will only retain your personal information for the period necessary to achieve the purposes
          stated in this Policy, unless an extended retention period is required or permitted by law.</p>
        <p>3. The Internet is not an absolutely secure environment, and communication methods such as email and instant
          messaging are not encrypted. We strongly recommend that you do not send personal information through such
          methods. Please use complex passwords to help us protect your account security.</p>
        <p>4. The Internet environment is not 100% secure. We will endeavor to ensure or guarantee the security of any
          information you send to us. If our physical, technical, or administrative protective measures are breached,
          resulting in unauthorized access, public disclosure, alteration, or damage to information, and causing damage
          to your lawful rights and interests, we will bear corresponding legal responsibility.</p>
        <p>5. Security Incident Handling</p>
        <p>In the unfortunate event of a personal information security incident, we will promptly inform you in
          accordance with the requirements of laws and regulations: the basic situation and possible impact of the
          security incident, the handling measures we have taken or will take, suggestions on how you can independently
          prevent and mitigate risks, and remedial measures for you, etc. We will promptly inform you of the incident
          details via email, letter, telephone, push notification, etc. When it is difficult to notify individual
          information subjects one by one, we will issue announcements through reasonable and effective methods.</p>
        <p>6. Location of Information Storage</p>
        <p>We comply with relevant provisions of laws and regulations and store user personal information collected
          within China.</p>
        <p>Please understand that, due to technical limitations and the limitations of risk prevention, even if we have
          strengthened security measures as much as possible, we cannot always guarantee that information is 100%
          secure. You should be aware that the systems and communication networks you use to access our services may
          experience issues due to circumstances beyond our control.</p>
        <div class="title">Article 5 How to Manage Your Information</div>
        <p class="bold">(1) Access, Correction, and Deletion</p>
        <p>Through the design of the interaction interfaces of each product, we provide you with channels to access,
          obtain, correct, and delete relevant personal information. You can query and access your account basic
          information (such as account ID, bound number) through the product you use:</p>
        <p class="bold">(2) Transfer of Your Personal Information</p>
        <p>If you need to transfer your personal information to another platform, enterprise, or organization, you can
          contact us through in-app online customer service. We will review your request in accordance with the
          requirements of laws and regulations and provide you with transfer assistance.</p>
        <p class="bold">(3) Changing or Withdrawing the Scope of Your Authorization and Consent</p>
        <p>You can change the scope of your authorization for us to collect and use your personal information by turning
          off or on specific product functions, or by turning off or on device permissions obtained by specific products
          (specific permissions vary depending on the device model and system version used). Please understand that
          after you withdraw your authorization, we will be unable to continue providing the services corresponding to
          the withdrawn authorization, and will no longer process your corresponding information. However, your decision
          to withdraw authorization will not affect the information processing previously carried out based on your
          authorization.</p>
        <p>If you wish to change or withdraw your consent for us to collect, use, and disclose other personal
          information, or if you wish us to correct, update, or delete your personal information, you may also contact
          us through the contact information in this Policy.</p>
        <p class="bold">(4) Account Deletion</p>
        <p>You can apply for account deletion through the channels informed within the product. You may also apply to us
          to delete your previously registered account by contacting in-app online customer service. To ensure account
          security, before processing deletion, we will verify your identity by sending an SMS verification code to your
          registered mobile phone number. From the date we receive your deletion request, we will complete processing
          within 15 working days. Please note: Account deletion is an irreversible operation. Once deletion is
          successful, you will be unable to log in or enjoy relevant services with that account. We will delete your
          personal information or anonymize it, unless otherwise required by laws and regulations.</p>
        <div class="title">Article 6 Protection of Minors' Personal Information</div>
        <p>1. We attach great importance to the protection of minors' personal information. In cases where we collect
          minors' personal information with the consent of parents or guardians when they use our products or services,
          we will only use, share, transfer, or disclose such information where permitted by laws and regulations, with
          the explicit consent of parents or guardians, or as necessary to protect minors.</p>
        <p>2. If we discover that we have collected a minor's personal information without first obtaining verifiable
          parental or legal guardian consent, we will seek to delete the relevant data as soon as possible. At the same
          time, we have established strict rules for the collection and use of minors' information to protect the
          security of minors' personal information. You can read the <span class="link"
            @click="tabActive = 'children'">Children's Personal Information Protection</span>
          Guidelines for more specific details.</p>
        <div class="title">Article 7 Notices and Amendments</div>
        <p>To provide you with better services, our business will change from time to time, and this Policy will be
          adjusted accordingly. Without your explicit consent, we will not reduce the rights you are entitled to under
          this Policy. We will notify you of relevant content updates by posting updated versions on our website and
          mobile platforms or by other means. Please visit us to stay informed of the latest privacy policy.</p>
        <div class="title">Article 8 How to Contact Us</div>
        <p>If you have complaints and reports regarding personal information security, or if you have any questions,
          comments, or suggestions regarding this Privacy Policy, matters related to your information, or regarding this
          Statement or our privacy measures, please contact us through in-app customer service or the following methods.
          We will review the issues involved as soon as possible and respond within no more than fifteen working days or
          the period prescribed by laws and regulations.</p>
        <p>• Send mail to the following address:</p>
        <p>Company Name: Fuzhou Yueciyuan Network Technology Co., Ltd.</p>
        <p>Address: Room 302, 3rd Floor, Building 1#, Fuzhou Shengxin Zhongchuang Network Technology Co., Ltd.
          Renovation Project, Cangshan Park, Pushang Area, Jinshan Industrial Concentration Zone, No. 44 Baihuazhou
          Road, Jianxin Town, Cangshan District, Fuzhou City, Fujian Province, China</p>
        <p>• Send email to the following email address:</p>
        <p>Email: service@joltrixtech.com</p>
      </section>
      <section v-else class="content">
        <div class="head">隐私政策</div>
        <p class="bold">更新日期：2026年09月01日</p>
        <p>本政策适用于福州市跃次元网络科技有限公司（以下简称“跃次元”或“我们”）负责开发、维护、运营的相关产品及服务（以下亦称“本服务”）。</p>
        <p>
          您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》（以下简称为“本政策”）向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本政策与您所使用的我们的服务息息相关，希望您仔细阅读。在需要时，按照本政策的指引，作出您认为适当的选择。本政策中涉及的相关技术词汇，我们尽量简明扼要的表述，以便您的理解。
        </p>
        <p class="bold">特别提示：未满14周岁的用户，同时适用本政策及《儿童个人信息保护指引》。如特定条款与本政策条款存在不一致约定的，以特定条款约定为准。</p>
        <p class="bold">若您是未满18周岁的未成年人，您需要在您的监护人的陪同下阅读本政策条款，请您和您的监护人务必仔细阅读；请您在取得您的监护人对本政策全部条款的同意之后使用我们提供的产品及服务。</p>
        <p class="bold">
          监护人特别说明：请帮助我们保护您监护的未成年人的个人信息和隐私安全，要求他们在您的监护下共同阅读并接受本政策，且应在您的同意和指导下提交个人信息、使用我们的服务。如果您不同意本政策内容，您应要求您监护的未成年人立即停止访问/使用我们的服务。
        </p>
        <div class="title">第一条 定义及说明</div>
        <p>1、个人信息：是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</p>
        <p>2、个人敏感信息：是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
        </p>
        <p>3、去标识化/匿名化处理：是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经去标识化处理后所得的信息不属于个人信息。</p>
        <div class="title">第二条 我们如何收集和使用您的个人信息</div>
        <p>我们提供服务时，可能会收集、储存和使用下列与您有关的信息。我们根据合法、正当、必要的原则，仅收集、使用实现产品功能所必要的信息。</p>
        <p class="bold">（一）您在使用我们的产品及服务时主动提供的信息：</p>
        <p>1、当您注册、登录账号使用产品及服务时，向我们提供的<strong>手机号码</strong>。我们会通过短信验证码来验证您的身份，以帮助您注册、登录账号；</p>
        <p>
          2、为履行网络游戏实名制的法定义务，落实未成年人防沉迷保护要求，并保障您的游戏账号安全，在您注册或登录我们的游戏产品服务时，我们需要您提供<strong>姓名、身份证号</strong>来验证您的真实身份。为实现实名认证的目的，您同意并授权我们向有关实名认证机构（国家网络游戏主管部门、公安部分或其委托/合作的其他机构）提供、查询、核对您的前述身份信息。如您不提供真实身份信息或提供虚假信息，您将无法登录、享受相关服务或在使用游戏过程中受到相应的限制。
        </p>
        <p>您承诺提供真实、合法、准确、有效的实名注册信息，且不得以他人身份资料进行实名注册。</p>
        <p>3、您通过我们的客服或参加我们举办的活动时所提交的信息</p>
        <p>
          例如，您参与我们线上活动时填写的调查问卷中可能包含您的<strong>性别、年龄、年级</strong>等信息，该信息用于分析统计、调整优化产品及服务，我们获取这些信息会进行去标识化处理，处理后的数据无法与您的个人身份直接关联。
        </p>
        <div class="title">（二）提供产品基础功能及服务</div>
        <p>1、为识别不同设备类型，确保产品界面适配与功能兼容，我们会收集您所使用的<strong>设备相关信息：设备品牌、设备型号、软件系统版本、屏幕分辨率</strong>。</p>
        <p>
          2、为实现服务器区域选择与内容本地化，我们还会获取<strong>SIM卡状态、获取运营商信息_SIM、获取运营商信息_NETWORK、获取SIM卡国家代码、设备语言、设备地域</strong>这些信息，用以自动匹配对应的服务器。
        </p>
        <p>3、为识别账号登录状态，进行多设备登录管理、数据统计、灰度测试及故障诊断，我们还会在必要时收集<strong>Android ID、OAID</strong>这些设备标识符信息。</p>
        <p>4、<strong>获取Wi-Fi参数、读取Wi-Fi状态、获取手机网络类型、获取网络状态</strong>。在您发起网络请求或下载任务时，我们可能会收集、获取这些信息和权限，用于判断当前网络环境是否可用。</p>
        <p>5、为确保您能及时获取产品的最新版本及安全补丁，在检测是否需要更新以及下载、安装更新包的过程中，我们需要收集您的<strong>应用版本、应用包名、应用名称、应用前后台状态以及应用列表信息</strong>。</p>
        <p>
          6、在您设备配置支持的情况下，为实现应用内场景画面的动画显示效果，进行辅助定位，基于移动设备姿态快捷调整游戏视角，我们会收集您设备的<strong>加速度传感器、陀螺仪传感器</strong>信息。请您理解，单独的设备传感器数据不涉及任何个人位置信息且无法与其他信息结合用于识别特定自然人的身份。
        </p>
        <p>
          7、在您使用我们的产品及服务时，我们会收集<strong>崩溃与错误日志信息、网络日志信息</strong>，用于故障诊断与系统异常定位，解决您在使用过程中遇到的故障问题。这些信息经过匿名化处理，不会与您的个人身份直接关联。
        </p>
        <p>8、为进行运营数据的统计分析，我们集成了第三方数据分析与统计SDK，该第三方SDK在您使用产品服务期间，可能会收集并处理GAID信息。</p>
        <p class="bold">（三）系统权限的调用</p>
        <p>您理解并同意，使用本服务的过程中，我们将在必要时申请访问您的系统权限，以实现这些权限所支持的产品功能。</p>
        <p>1、您在应用内联系客服场景上传照片/图片/视频时，我们会访问设备<strong>相册权限</strong>，以实现您与客服沟通提供证明的功能。</p>
        <p>
          2、为了及时向您提供产品及服务的动态，我们会获取您的<strong>消息推送权限</strong>，向您推送活动通知及进展。您可以在设备设置功能中选择关闭消息推送功能，关闭后您将无法收到应用内消息推送，但不影响您使用其他功能。
        </p>
        <p class="bold">（四）订单支付服务</p>
        <p>
          您可以通过向我们付款的方式获取我们的产品及/或服务相关的虚拟产品，包括但不限于游戏币、游戏道具。请您注意，支付功能由与我们合作的第三方支付机构向您提供。第三方支付机构可能需要收集支付功能所必需的信息。我们不会获取与您付款相关的支付账号、密码信息。在您成功付款后，我们仅会从该第三方支付机构处获取您已完成付款的结果验证信息，进而向您提供相应虚拟产品。若您希望了解第三方支付机构收集个人信息的具体规则，请参阅您选择的第三方支付机构的隐私政策。
        </p>
        <p>
          为向您展示账号的交易信息并保障交易安全，我们会收集您在使用我们的产品及/或服务过程中产生的信息（包括您所购买的<strong>商品或服务信息、具体订单号、订单创建时间、交易金额</strong>）用于向您展示及便于您对订单进行管理。
        </p>
        <p class="bold">（五）征得授权同意的例外</p>
        <p>根据相关法律法规规定，以下情形中收集您的信息无需征得您的授权同意：</p>
        <p>（1）与国家安全、国防安全有关的；</p>
        <p>（2）与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>（3）与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>（4）出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的</p>
        <p>（5）所收集的信息是您自行向社会公众公开的；</p>
        <p>（6）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；</p>
        <p>（7）根据您的要求签订合同所必需的；</p>
        <p>（8）用于维护我们的服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
        <p>（9）为合法的新闻报道所必需的；</p>
        <p>（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</p>
        <p>（11）法律法规规定的其他情形</p>
        <div class="title">第二条 我们可能分享、转让或披露的信息</div>
        <p class="bold">（一）分享</p>
        <p>除以下情形外，未经您同意，我们不会与任何第三方分享您的个人信息：</p>
        <p>1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</p>
        <p>2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</p>
        <p>3、与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会根据最小必要原则共享必要的个人信息，且受本政策中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
        <p class="bold">（二）转让</p>
        <p>
          1、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而您的信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。
        </p>
        <p>2、在获得您的明确同意后，我们会向其他方转让您的信息。</p>
        <p class="bold">（三）披露</p>
        <p>我们或我们的关联公司仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露您的信息：</p>
        <p>1、根据您的需求，在您明确同意的披露方式下披露您所指定的信息；</p>
        <p>2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</p>
        <p>3、为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</p>
        <div class="title">第三条 关于Cookie</div>
        <p class="bold">（一）什么是Cookie</p>
        <p>
          当您使用我们的产品时，我们会在您的计算机或移动设备上设定或取用名为Cookie的小型数据文件。当您登录账号时，借助于Cookie，我们可以在您每次使用我们的产品时识别您是否属于我们的用户；还可以实现直接从一个页面跳转到另一个页面，而不必在每个页面上重新登录。网站信标、像素或其他类似文件也可以做同样的事情。我们在本政策中使用术语“Cookies”来指代以这种方式收集信息的所有文件。
        </p>
        <p class="bold">（二）我们如何使用Cookie</p>
        <p>
          我们使用Cookies来判断您是否已经登录而不必在每个页面上重新登录、记录您曾浏览过的页面以便您下次更快速、便捷地浏览并提升服务质量及优化用户体验。我们还通过Cookie启用支持安全功能，监控和防止可疑活动、欺诈性流量和违反我们的用户协议的行为。我们不会将Cookie用于本政策所述目的之外的任何其他用途。
        </p>
        <p class="bold">（三）接受或拒绝Cookie</p>
        <p>您有权选择接受或拒绝接受Cookie。您可以通过修改浏览器设置的方式或在移动设备中设置拒绝接受Cookie。但如果您选择拒绝接受Cookie，则您可能无法登录或使用依赖于Cookie的服务。</p>
        <div class="title">第四条 我们如何保留、储存和保护信息</div>
        <p>1、我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。</p>
        <p>2、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
        <p>3、互联网并非绝对安全的环境，而且电子邮件、即时通讯等用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保护您的账户安全。</p>
        <p>
          4、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或损坏，导致您的合法权益受损，我们将承担相应的法律责任。
        </p>
        <p>5、安全事件处置</p>
        <p>
          在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
        </p>
        <p>6、信息存储的地点</p>
        <p>我们遵守法律法规的相关规定，将境内收集的用户个人信息存储于境内。</p>
        <p>请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您使用我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。</p>
        <div class="title">第五条 如何管理您的信息</div>
        <p class="bold">（一）访问、更正和删除</p>
        <p>我们通过各产品交互界面的设计，为您提供了访问、获取、更正、删除相关个人信息的渠道，您可通过使用的产品中查询和访问您的账号基础信息（如账号ID、绑定号码）：</p>
        <p class="bold">（二）转移您的个人信息</p>
        <p>若您需要将您的个人信息转移至其他平台、企业或组织，您可通过产品内在线客服与我们联系，我们将根据法律法规的要求，对您的请求进行审核并为您提供转移帮助。</p>
        <p class="bold">（三）改变或撤销您授权同意的范围</p>
        <p>
          您可通过关闭或开启特定产品功能、关闭或开启特定产品获取的设备权限（具体权限因用户使用的设备型号、系统版本不同而存在差异），变更对我们收集和使用您的个人信息的授权范围。请您理解，当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。
        </p>
        <p>如果您希望改变或撤销同意我们收集、使用和披露您的其他个人信息或者希望我们更正、更新或删除您的个人信息，也可通过本政策中的联系方式与我们联系。</p>
        <p class="bold">（四）注销</p>
        <p>
          您可通过产品内告知的渠道申请注销。您也可通过联系产品内在线客服向我们申请注销此前注册的账号。为保障账号安全，我们在处理注销前会通过向您的注册手机号发送短信验证码的方式验证您的身份。自收到您的注销申请之日起，我们将在15个工作日内完成处理。请您特别注意：注销账号是不可逆操作，一旦注销成功，您将无法使用该账号登录及享受相关服务。我们将删除您的个人信息或进行匿名化处理，但法律法规另有要求的除外。
        </p>
        <div class="title">第六条 未成年人个人信息保护</div>
        <p>1、我们非常重视对未成年人个人信息的保护。对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。
        </p>
        <p>
          2、如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，我们会设法尽快删除相关数据。同时，我们建立了严格的未成年人信息收集使用规则，以保护未成年人个人信息安全，您可以通过阅读<span
            class="link" @click="tabActive = 'children'">《儿童个人信息保护指引》</span>了解更具体的内容。</p>
        <div class="title">第七条 通知和修订</div>
        <p>
          为给您提供更好的服务，我们的业务将不时变化，本政策也将随之调整。未经您明确同意，我们不会削减您依据本政策所应享有的权利。我们会通过在我们网站、移动端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。
        </p>
        <div class="title">第八条 如何联系我们</div>
        <p>
          如您有关于个人信息安全的投诉和举报，或您对本隐私政策、您的信息的相关事宜有任何问题、意见或建议，以及有关本声明或我们的隐私措施的问题，请通过产品内客服或以下方式与我们联系。我们将尽快审核所涉问题，最长在不超过十五个工作日或法律法规规定期限内予以回复。
        </p>
        <p>• 邮寄信件到以下地址：</p>
        <p>公司名称：福州市跃次元网络科技有限公司</p>
        <p>地址：福建省福州市仓山区建新镇百花洲路44号金山工业集中区浦上片仓山园福州圣信众创网络科技有限公司提升改造项目1#楼3层302</p>
        <p>• 发送邮件到以下邮箱：</p>
        <p>邮箱：service@joltrixtech.com</p>
      </section>
    </div>
    <div v-if="tabActive == 'user'">
      <section v-if="isOverseas" class="content">
        <div class="head">USER SERVICE AGREEMENT</div>
        <p class="bold">Updated on: April 9, 2025</p>
        <div class="title">PREAMBLE</div>
        <p>This User Service Agreement (hereinafter referred to as "this Agreement") is a legally binding
          agreement entered into between you and Fuzhou Joltrix Co., Ltd.(hereinafter referred to as "Joltrix"
          or "we") regarding the relevant application products and services (hereinafter also referred to as
          "the
          Service")
        </p>
        <p class="bold">
          Special Notice for Minors: If you are under 18, please read this with your guardian. You may only
          use the Service and perform recharges after obtaining your guardian's consent.
        </p>
        <div class="title">ARTICLE 1: DEFINITIONS</div>
        <p>1. This Agreement: Includes the main text, the "Privacy Policy," and all future updates.</p>
        <p>2. The Service: Refers to all products and services operated by Fuzhou Joltrix Co., Ltd.</p>
        <p>3. User: The natural person obtaining the Service through legal channels.</p>

        <div class="title">ARTICLE 2: ACCOUNT MANAGEMENT</div>
        <p>1. Registration: Upon successful registration, you obtain a user account.</p>
        <p>2. Security: You are responsible for safeguarding your password. You shall bear legal liability for
          any account theft caused by your negligence.</p>
        <p class="bold">
          3. Restrictions: Selling, lending, or sharing accounts is strictly prohibited. You are responsible
          for all activities under your account.
        </p>
        <p>4. Data Accuracy: You must provide accurate personal information for identity verification and
          support.</p>

        <div class="title">ARTICLE 3: USER RIGHTS</div>
        <p>1. Grant of License:<span class="bold">Joltrix grants a personal, non-transferable, non-exclusive
            license for non-commercial use.</span></p>
        <p>2. Feedback: Users have the right to provide suggestions.</p>
        <p>3. Termination by User: You may stop using the Service at any time if you disagree with any terms.
        </p>

        <div class="title">ARTICLE 4: CODE OF CONDUCT</div>
        <p class="bold">1. Prohibited Acts: Users shall not engage in activities that endanger national
          security, incite hatred, spread obscenity, or insult others.</p>
        <p class="bold">2. Technical Interference: Attacks on servers, software cracking, and exploiting
          "Bugs" are strictly prohibited.</p>
        <p class="bold">3. IP Protection: Unauthorized copying, modification, or commercial use of product
          content is prohibited.</p>
        <p class="bold">4. Trading: Offline trading of virtual items or accounts for profit is not permitted.
        </p>

        <div class="title">ARTICLE 5: HANDLING OF VIOLATIONS</div>
        <p class="bold">For violations, Joltrix may issue warnings, suspend or ban accounts, delete data, or
          pursue legal liability. All improper gains may be confiscated.</p>

        <div class="title">ARTICLE 6: RIGHTS OF Joltrix</div>
        <p class="bold">
          1. Adjustments: Joltrix may update service elements or character designs.
        </p>
        <p class="bold">
          2. Maintenance: Inactive accounts may be deleted after prior notice.</p>
        <p class="bold">
          3. Termination: Joltrix may terminate operations in accordance with the law.
        </p>

        <div class="title">ARTICLE 7: LIMITATION OF LIABILITY</div>
        <p>1. Warranties:<span class="bold"> Service is provided "as is." Joltrix is not liable for
            interruptions caused by force majeure or hackers.</span></p>
        <p class="bold">2. Data Restoration: In case of data anomalies due to bugs, Joltrix may restore data
          to a previous state.</p>
        <p class="bold">3. Compatibility: Users assume risks when switching between incompatible operating
          systems.
        </p>

        <div class="title">ARTICLE 8: TARIFF POLICY</div>
        <p>1. Pricing: Rates are determined by Joltrix and published in the Service.</p>
        <p class="bold">
          2. Refunds: Payments are non-refundable unless required by law. Transaction fees may be deducted
          from any granted refunds.
        </p>

        <div class="title">ARTICLE 9: MINORS PROTECTION</div>
        <p>Joltrix implements anti-addiction systems. Guardian consent is required for all purchases.
        </p>
        <div class="title">ARTICLE 10: INTELLECTUAL PROPERTY</div>
        <p class="bold">
          1. Ownership: All software, art, and trademarks belong to Joltrix.
        </p>
        <p>2. Server Data: All data stored on Joltrix's servers (except personal ID info) belongs to
          Joltrix.</p>

        <div class="title">ARTICLE 11: GOVERNING LAW AND JURISDICTION</div>
        <p>1. Law: This Agreement is governed by the laws of the People's Republic of China.</p>
        <p>2. Jurisdiction: Disputes shall be submitted to the People's Court of Cangshan District, Fuzhou City.
        </p>
        <div class="title">ARTICLE 12: MISCELLANEOUS</div>
        <p>1. Effectiveness: This Agreement takes effect upon your first use or registration.
        </p>
        <p>2.Interpretation: To the extent permitted by law, Joltrix reserves the right of final interpretation.
        </p>
      </section>
      <section v-else class="content">
        <div class="head">用户服务协议</div>
        <p class="bold">更新日期：2025年04月09日</p>
        <div class="title">【前言】</div>
        <p>《用户服务协议》（以下简称“本协议”）是由您与福州市跃次元网络科技有限公司（以下简称“跃次元”或“我们”）就其提供的相关应用产品及服务（以下亦称“本服务”）所订立的具有法律效力的协议。</p>
        <p class="bold">
          您在使用跃次元的产品及服务之前，请您认真阅读并充分理解本协议的全部条款，特别是其中免除或者限制责任的条款（该条款通常含有“不得”、“不应”、“禁止”、“无权”等词汇）、法律适用和管辖条款以及开通或使用某项服务的单独协议。
        </p>
        <p class="bold">
          如果您是未满18周岁的未成年人，请在监护人的陪同下阅读本协议，并特别注意未成年人使用条款。在您的监护人同意本协议的全部条款及您使用跃次元的产品及服务的行为后，您方可使用跃次元的产品及服务。您在本服务的充值购买行为亦需取得您监护人的同意。
        </p>
        <p class="bold">如果您不同意本协议的条款，请不要安装、使用本服务，您点击同意、接受或下一步，或您注册、使用本服务均视为您已详细阅读并接受本协议的全部条款，并同意签署本协议。
        </p>

        <div class="title">第一条 定义及说明</div>
        <p>本协议中，如无相反说明，以下词语具有如下含义：</p>
        <p>1、本协议：指本协议正文、《隐私政策》及其修订、更新版本。上述内容一经发布，即为本协议不可分割的组成部分。</p>
        <p>2、跃次元的产品及服务：指由福州市跃次元网络科技有限公司运营的应用产品及服务的统称。</p>
        <p>3、您：又称“用户”，指通过跃次元提供的合法途径获得跃次元的产品及服务的自然人。</p>

        <div class="title">第二条 账号注册及管理</div>
        <p>1、当您阅读并同意本协议，成功完成注册后，即成为跃次元产品的注册用户，取得使用跃次元产品及服务的用户账号。</p>
        <p>2、您有义务妥善保管您的账号及密码，并正确、安全地使用账号及密码。如您未尽义务导致账号密码遗失、账号被盗等情形而给跃次元或他人的权利造成损害的，应当承担由此产生的法律责任。</p>
        <p class="bold">
          3、您对于账号及密码的保管以及使用该账号和密码所进行的一切行为负有完全的责任。跃次元禁止将账号或密码以销售、转让、出借、共享等方式提供给他人使用的行为，因为您的保管疏忽或任何第三方行为，导致您的账号或密码遭他人非法使用，以及因此而产生的任何后果及责任均由您自行负担，跃次元均不承担任何责任，且跃次元有权对您的账号采取包括但不限于警告、限制或禁止使用账号全部或部分功能，删除账号及数据及其他相关信息、封号直至注销的处理措施。
        </p>
        <p>4、若您发现账号或密码被他人非法使用或有使用异常情况的，应及时通知跃次元，并有权请求跃次元采取措施暂停该账号的登录和使用。跃次元会根据您身份核对结果，决定是否暂停您的账号的登录和使用。</p>
        <p>
          5、基于跃次元提供服务的重要性，您同意提供详细准确的个人资料，并不断更新注册资料，以符合及时、详尽、准确的要求。您应牢记填写的注册资料、历史信息。您理解并同意，如果不能提供准确完整的您信息，将可能导致跃次元无法判断您的身份，从而无法为您提供密码找回等相关服务及其他必要的支持，而跃次元对此不承担任何责任。
        </p>

        <div class="title">第三条 用户基本权利</div>
        <p>1、在您遵守相关法律、法规及本协议的前提下，<span class="bold">跃次元给予您个人的、不可转让及非排他性的使用跃次元产品及服务的权利，但您仅可为非商业的目的使用跃次元产品及服务。</span></p>
        <p>2、您有权在使用跃次元产品及服务期间随时向跃次元提出关于产品及服务的相关意见及建议。</p>
        <p>3、如果您不同意本协议条款，或对跃次元后来修改、更新的条款有异议，或对跃次元产品及服务不满意，您可以随时选择停止使用跃次元产品及服务。
          如果您选择停止使用跃次元产品及服务的，跃次元不再对您承担任何义务和责任。</p>

        <div class="title">第四条 用户行为准则</div>
        <p>1、 您必须为自己账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果，如因此给跃次元造成损失的，跃次元有权向您追偿。</p>
        <p class="bold">2、您在使用跃次元产品及服务时，须遵守法律法规，不得利用跃次元产品及服务从事任何违法违规行为，包括但不限于如下行为：</p>
        <p>（1）违反宪法确定的基本原则的；</p>
        <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p>（3）损害国家荣誉和利益的；</p>
        <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
        <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
        <p>（7）散布淫秽、色情、不雅、低俗、赌博、暴力、凶杀、恐怖信息或者教唆犯罪的；</p>
        <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
        <p>（9）违背公序良俗及社会公德的；</p>
        <p>（10）中华人民共和国法律、行政法规禁止的其他行为。</p>
        <p class="bold">3、您不得干扰跃次元正常地提供服务，包括但不限于：</p>
        <p>（1）攻击、侵入跃次元的网站服务器或使网站服务器过载；</p>
        <p>（2）破解、修改跃次元产品软件程序；</p>
        <p>（3）攻击、侵入跃次元服务器/服务器端程序或使服务器过载；</p>
        <p>（4）未经允许，进入跃次元科技计算机信息网络系统或者使用计算机信息网络系统资源；</p>
        <p>（5）自行删除、修改或者跃次元服务计算机信息网络功能或对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</p>
        <p>（6）故意制作、传播计算机病毒等破坏性程序的；</p>
        <p>（7）制作、使用、发布、传播任何形式的妨碍跃次元服务公平性的辅助工具或程序；</p>
        <p>（8）利用程序的漏洞和错误(Bug)破坏本服务的正常进行或传播该漏洞或错误(Bug)；</p>
        <p>（9）直接或间接利用产品Bug（包括系统、程序、设定等方面存在的漏洞或不合理的现象）、程序漏洞获利或扰乱服务秩序，或者利用Bug、漏洞达到个人目的；</p>
        <p>（10）通过异常或者非法的方式使用本服务或使用异常的方法登录跃次元产品(包括但不限于登录私服、使用非跃次元开发、授权或认可的第三方软件、系统登录跃次元产品）；</p>
        <p>（11）对跃次元产品进行反向工程、反向汇编、反向编译或者以其他方式尝试发现软件的源代码；</p>
        <p>（12）修改客户端程序，使之改变或者新增或者减少跃次元产品软件所预先设定的功能，或者导致客户端向服务器发送的数据出现异常的一切行为。</p>
        <p>（13）其他危害计算机信息网络安全或影响跃次元正常提供产品及服务的行为。</p>
        <p class="bold">4、除非事先征得跃次元书面同意，您不得实施下列行为，无论该行为是营利性的还是非营利性的：</p>
        <p>（1）公开展示和播放跃次元产品的全部或部分内容；</p>
        <p>（2）出租、销售跃次元产品软件或者利用跃次元产品软件从事营利行为；</p>
        <p>（3）修改或遮盖跃次元产品程序、图像、动画、包装等内容上的产品名称、公司标志、版权信息等内容；</p>
        <p>（4）其他违反著作权法、商标法、计算机软件保护条例和相关法律法规的行为。</p>
        <p class="bold">5、您应遵循文明、健康的方式使用本服务、不得为以下行为，扰乱跃次元的产品服务秩序：</p>
        <p>（1）通过任何方式、行为冒充系统散布虚假、不实信息；</p>
        <p>（2）通过任何方式、行为散布或传播低俗、不雅信息及虚假信息；</p>
        <p>（3）发布含有跃次元未认可的软件、文件、广告信息链接或非法网站等；</p>
        <p>（4）大量传播相同的、类似短语或无实质意义内容的言行，以及任何与跃次元产品无关的信息(包括但不限于刷屏等)，或者发布、传播任何贬损、诋毁、恶意攻击“跃次元产品或跃次元的信息；</p>
        <p>（5）宣扬、教唆使用虚拟道具、虚拟货币线下交易以及木马、病毒等破坏产品服务秩序的相关内容；</p>
        <p>（6）通过各种方式或途径引起地区纷争或宣扬藏独、台独等祖国分裂信息；</p>
        <p>（7）在使用本服务场景中涉及种族、宗教、政治、国家领导人、淫秽、低俗、诽谤、恐吓、暴力、欺诈性的、攻击性的、污辱性的、可能引起误会的、违禁药品等内容或用以上内容给用户角色、帮派命名；</p>
        <p>（8）盗号及盗号相关行为（包括但不限于盗取用户账号、数据、用户个人资料、协助盗号者操作及转移服务虚拟物品、接收他人通过盗号方式取得的虚拟物品等行为）；</p>
        <p>（9）泄露其他用户个人信息的；</p>
        <p>（10）以营利为目的使用本服务或交易服务虚拟物品（任何以营利为目的使用本服务行为或交易虚拟物品的情形均将被视为牟取不正当利益，跃次元有权没收该不正当利益）；</p>
        <p>（11）以某种方式暗示或伪称跃次元内部员工或某种特殊身份，企图得到不正当利益或影响其他用户权益的行为；</p>
        <p>（12）其他在行业内被广泛认可的不当行为，无论是否已经被本协议明确列明。</p>
        <p>6、一旦跃次元通过内部的检测程序发现您的行为或者数据异常或者经其他用户举报而发现您有可能正在从事违反用户行为准则的行为的，跃次元有权做出独立的判断并根据本协议第五、六条采取相应的措施。</p>

        <div class="title">第五条 对用户违反行为准则的处理</div>
        <p class="bold">如果您违反了用户行为准则中的一条或者几条，跃次元有权根据情节轻重，采取以下一种或多种处理方式：</p>
        <p>1、警告：警告是针对轻微违反服务规则的用户做出的教育导向，它是用于正常管理服务运行的一种方式。</p>
        <p>2、封停账号：暂停或永久停止违规用户账号登录使用。</p>
        <p>3、删除档案数据：将违规用户在跃次元产品中的档案数据删除。</p>
        <p>4、修改昵称和头像：强制修改违规用户账号昵称、人物等的名称和头像。</p>
        <p>5、封禁IP：暂时或永久禁止违规用户在某一异常IP登录跃次元产品的某个服务器。</p>
        <p>6、承担法律责任：用户的不当行为对他人或者跃次元造成损害或者与现行法律、法规规定相违背的，违规用户要依法承担相应的民事、行政或刑事责任。</p>
        <p>7、其他措施：包括但不限于没收不正当利益（如用户通过不正当途径获得的虚拟物品）、暂时中断服务等。</p>
        <p>
          用户违反用户行为准则的，跃次元除有权采取以上措施外，还有权追究用户的违约责任，包括但不限于恢复原状，消除影响，对给跃次元造成的直接及间接损失或因此支出的费用进行赔偿。若跃次元首先承担了因违规用户行为导致的行政处罚或侵权损害赔偿责任后，跃次元有权向违规用户追偿。
        </p>

        <div class="title">第六条 跃次元的权利</div>
        <p class="bold">
          1、您充分理解并同意，为更好地提供服务，跃次元有权对本服务中的任何内容或构成元素等作出调整、更新或优化（包括但不限于对您正在使用或已购买的角色及其他道具的美术设计、性能及相关数值设置等作出调整、更新或优化等）。
        </p>
        <p class="bold">
          2、您充分理解并同意，为提高产品及服务的安全水平，跃次元有权将有关技术或软件应用到跃次元产品中，但跃次元不保证这些安全保障措施可以完全杜绝您的账号被他人窃取或丢失的风险。</p>
        <p class="bold">
          3、您充分理解并同意，为高效利用服务器资源，跃次元有权进行如合并服务器等相关的管理行为。如果您长期未使用账号登录产品，跃次元有权视需要，在提前通知的情况下，对该账号及其账号下的数据及相关信息采取删除等处置措施，上述处置可能导致您对该账号下相关权益的丧失，对此产生的责任由您自行承担，跃次元不承担任何责任。
        </p>
        <p>4、跃次元有权自行决定终止运营一款或几款产品及服务，终止运营时，跃次元会按照有关法律规定处理终止运营相关事宜，以保障您的合法权益。</p>

        <div class="title">第七条 责任限制</div>
        <p>1、在法律允许的最大限度内，跃次元明确表示不作任何类型的担保（不论是明确的或隐含的担保）。<span class="bold">跃次元不担保下述事项，且不对用户因此产生的损失承担责任：</span></p>
        <p>（1）跃次元产品及服务仅与跃次元已明确公告的服务及承诺相符，跃次元不保证满足用户的其他要求；</p>
        <p>（2）跃次元产品及服务不受不可抗力、国家政策、法律法规、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机、电信部门原因及其他任何网络、技术、通信线路、他人故意或过失行为等外界或人为因素的影响；
        </p>
        <p>（3）安装、复制、访问网站、充值、运行跃次元产品或以其它方式使用跃次元产品及服务与任何其他软件不存在任何冲突；</p>
        <p>（4）通过跃次元官方网站、官方微博、公众号及应用产品内或其他相关网络上的链接和标签所指向的第三方的商业信誉及其提供服务的真实性、有效性和合法性。</p>
        <p class="bold">
          2、跃次元产品可能因软件BUG、版本更新缺陷、第三方病毒攻击或其他任何因素导致您的账号数据发生异常。在数据异常的原因未得到查明前，跃次元有权暂时冻结该账号；若查明数据异常为非正常使用行为，跃次元有权恢复该账号数据至异常发生前的原始状态（包括向第三方追回被转移数据），且无须向您承担任何责任。
        </p>
        <p class="bold">
          3、您充分理解并同意，不同操作系统之间可能存在不互通的客观情况，由此可能导致您在某一操作系统中的充值和账号数据不能顺利转移到另一操作系统中。由于您在不同系统进行切换造成的充值损失和账号数据丢失风险应由您自行承担，不得要求跃次元承担任何责任。
        </p>
        <p class="bold">
          4、在法律允许的最大限度内，跃次元对您使用跃次元产品及服务引起的任何间接、偶然、意外、特殊或继起的损害（包括但不限于人身伤害、隐私泄漏、财产损失等）不负责任，这些损害可能来自：您或他人不正当使用产品及服务、私自通过线下或非官方渠道购买商品或服务等。
        </p>
        <p>5、由于您个人失误、错误或不当操作导致的任何后果，由您自行承担责任，跃次元不予任何赔偿或补偿。</p>

        <div class="title">第八条 资费政策</div>
        <p>1、跃次元有权决定产品及服务的资费标准及收费方式，跃次元有权根据需要不定时调整资费标准及收费方式。跃次元将在产品内商城、道具购买界面等模块上，详细公布产品及服务的收费标准。</p>
        <p class="bold">
          2、您有义务在选择前仔细阅读，一旦您选择购买产品内相关虚拟物品或者接受相关服务，则表明您已经充分理解并接受相应的收费方式和资费标准。除非法律另有明文规定或者跃次元另有明确公示，否则您不得要求返还其已经支付的任何资费（以下简称“退款”），无论该等资费是否已被消费。跃次元有权决定是否、何时、以何种方式向您退款。跃次元同意退款的，您应补偿支付时使用信用卡、手机等支付渠道产生的费用，跃次元有权在返还您的资费中直接扣收。跃次元在产品和服务提供过程中赠送的充值金额、虚拟货币、虚拟道具等，不予退款或变现。
        </p>

        <div class="title">第九条 未成年人保护</div>
        <p>
          1、跃次元将按照相关法律法规和本协议的规定，采取切实有效的措施保护未成年人在使用跃次元产品及服务过程中的合法权益，包括可能采取技术措施、限制未成年人的使用时间，预防未成年人沉迷网络。用户在使用跃次元产品及服务的过程中应避免发布、产生任何有损未成年人身心健康的内容，共同营造健康游戏环境。
        </p>
        <p class="bold">
          2、未成年用户需在取得监护人同意后方可在跃次元产品中进行消费行为，一旦未成年用户选择购买服务虚拟物品或进行其他消费行为将视为其已取得监护人的同意。跃次元不接受用户购买物品及服务后以未取得监护人同意为理由申请退款的行为。
        </p>

        <div class="title">第十条 知识产权条款</div>
        <p class="bold">
          1、跃次元依法享有跃次元产品（包括跃次元产品整体及涉及的所有内容、组成部分或构成要素）的一切合法权益，包括但不限于其中涉及的计算机软件著作权、美术作品著作权和专利权等知识产权以及运营游戏软件的权利等。除非事先经跃次元书面合法授权，或法律另有明文规定，您不得擅自以任何形式使用、复制、传播、伪造、模仿、修改、改编、翻译、汇编、出版、进行反编译或反汇编等反向工程，否则跃次元有权立即终止为您提供产品及服务，并依法追究您的知识产权侵权责任，要求其赔偿跃次元的一切损失。
        </p>
        <p>2、跃次元产品中所体现的“跃次元、产品徽标（图形）和/或跃次元的产品和服务标示”均属于跃次元合法享有，您未经合法授权不得自行使用。</p>
        <p>3、跃次元并未因为本协议或者因为向您提供产品以及相关服务而授予您任何由跃次元拥有的相关的知识产权。本协议未明确授予您的权利均由跃次元保留。</p>
        <p>
          4、您在使用本务过程中产生并储存于跃次元产品服务器中的任何数据信息（包括但不限于账号数据信息、角色数据信息、虚拟物品数据信息等，但您的姓名、身份证号、电话号码等个人身份数据信息除外）属于跃次元产品的一部分，由跃次元所有并进行管理，您有权在遵守本服务规则的前提下通过跃次元指定的途径对属于自身账号的数据信息进行修改、转移、处分。
        </p>
        <p>5、为保证准确及避免争议，本协议涉及到的有关技术方面的数据、信息，您同意以跃次元产品服务器所储存的数据作为判断标准。跃次元保证该数据的真实性。</p>

        <div class="title">第十一条 服务的中断、中止、终止</div>
        <p>1、 如您存在违反法律、法规或本协议约定特别是违反本协议中规定的用户行为准则时，跃次元有权视情节轻重中断、中止或终止为您提供本服务。</p>
        <p>2、为保障产品及服务的正常运行，跃次元需要定期对产品和/或服务器进行维护或针对突发事件进行紧急维护；因上述情况而造成的正常服务中断、中止，您予以理解并同意，跃次元尽力将中断时间限制在最短时间内。
        </p>
        <p class="bold">3、发生下列情形之一时，跃次元有权在不提前通知您的情况下中止或中断服务器所提供之全部或部分服务，对因此而产生的不便或损害，跃次元对您或第三人均不承担任何责任：
        </p>
        <p>（1）定期检查或施工，更新软硬件等，跃次元有权暂停服务，但会尽快完成维护、更新工作；</p>
        <p>（2）服务器遭受损害，无法正常运作；</p>
        <p>（3）突发性的软硬件设备与电子通信设备故障；</p>
        <p>（4）网络提供商线路或其他故障；</p>
        <p>（5）在紧急情况之下依照法律的规定或为您及第三者之人身安全；</p>
        <p>（6）第三方原因或其他不可抗力的情形。</p>

        <div class="title">第十二条 损害赔偿</div>
        <p>
          1、您同意保障和维护跃次元及其他用户的利益，如因您违反有关法律、法规或本协议项下的任何条款而给跃次元造成损害，您同意承担由此造成的损害赔偿责任，该等责任包括但不限于给跃次元造成的任何直接或间接损失。若跃次元首先承担了因您的违法、违约行为导致的行政处罚或侵权损害赔偿责任后，跃次元有权向您追偿。
        </p>
        <p>2、如您违反本协议、跃次元发布的其他规则或者国家法律法规规定，则跃次元有权做出独立的判断，立即终止为您提供服务并通过各种合法途径追究您的法律责任。</p>

        <div class="title">第十三条 个人信息保护</div>
        <p>
          1、个人信息是指是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。跃次元非常注重保护您的个人信息及隐私，我们深知个人信息对您的重要性，并将按照法律法规要求和业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。您在下载、安装、启动、浏览、注册、登录、使用跃次元的产品与/或服务时，我们将按照《跃次元隐私政策》的约定收集、处理、分享您的个人信息。
        </p>
        <p>2、<span
            class="bold">您应当在仔细阅读、充分理解《跃次元隐私政策》以及我们保护这些信息的方式后使用跃次元的产品与/或服务。</span>如果您不同意隐私政策的内容，将可能导致跃次元的产品与/或服务无法正常运行，或者无法达到我们拟达到的服务效果。您使用或继续使用跃次元提供的产品与/或服务的行为，都表示您充分理解和同意《跃次元隐私政策》（包括更新版本）的全部内容。
        </p>
        <div class="title">第十四条 法律适用及管辖</div>
        <p>1、 本协议的订立、效力、解释、履行及争议解决适用中华人民共和国法律。如果本协议的任何内容与法律相抵触，应以法律规定为准。</p>
        <p>2、 如双方就本协议内容或其执行发生任何纠纷，双方应尽量友好协商解决。协商不成时，任何一方均应向福州市仓山区人民法院提起诉讼。</p>
        <div class="title">第十五条 其他约定</div>
        <p>1、跃次元所有发给您的通知可通过跃次元的官方网站或跃次元其他平台页面的公告、电子邮件或常规的电话、信件等形式传送。</p>
        <p>2、本协议于您完成跃次元账号注册之日签订并生效。即便您没有完成账号注册，但通过其他任何方式获得和使用跃次元产品及服务的，本协议于您获得及使用产品和服务之日签订并生效。</p>
        <p>3、如本协议中的任何条款因任何原因被判定为完全或部分无效或不具有执行力的，该无效或不具有执行力的条款将被最接近原条款意图的一项有效并可执行的条款所替代，并且本协议的其余条款仍应有效并且有执行力。
        </p>
        <p>4、跃次元不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响跃次元在将来行使该权利。</p>
        <p>5、跃次元有权在必要时变更本协议条款，您可以在产品内的相关页面查阅最新版本的协议条款。本协议条款变更后，如果您继续使用跃次元产品及服务，即视为您已接受变更后的协议。</p>
        <p>6、在法律允许的最大范围内，跃次元保留对本协议的最终解释权。</p>
      </section>
    </div>
    <div v-if="tabActive == 'children'">
      <section v-if="isOverseas" class="content">
        <div class="head">Children's Personal Information Protection Guidelines</div>
        <p class="bold">Last Updated: 01/09/2026</p>
        <p class="bold">Special Notice to Children's Guardians: If you are the guardian of a child user, please read
          carefully and decide whether you agree to these Guidelines. We hope that you will work with us to protect
          children's personal information, educate and guide children to enhance their awareness and ability to protect
          their personal information, and instruct, remind, and require them not to provide any personal information to
          any online product or service provider without your consent.</p>
        <p class="bold">Special Notice to Children: If you are a minor under the age of 14, you need to read these
          Guidelines carefully together with your guardian, and use our products, services, or provide information to us
          only after obtaining your guardian's consent.</p>
        <div class="title">I. How We Collect and Use Children's Personal Information</div>
        <p class="bold">(1) We will strictly comply with the provisions of laws and regulations and our agreements with
          users, follow the principles of legitimacy and necessity, informed consent, clear purpose, security
          safeguards, and lawful use, and collect and use children's personal information only after obtaining the
          guardian's consent:</p>
        <p>1. Pursuant to legal and regulatory requirements, when you use our game products (such as Kalliu World), we
          require users to provide their name and valid identification information for real-name authentication. If the
          user is identified as a child, we will process their personal information in accordance with the provisions of
          laws and regulations.</p>
        <p>2. When we identify that a user is a child, we will collect the guardian's contact information (mobile phone
          number, email address) and other information that helps us determine the guardianship relationship, in order
          to verify the guardianship relationship between the guardian and the child, and to help the guardian manage
          and understand the child's use of products or services.</p>
        <p>3. During a child's use of products or services, we will also collect other relevant information. For
          details, please refer to the section "How We Collect and Use Your Personal Information" in the Privacy Policy
          to learn more about the other children's personal information we collect.</p>
        <p>4. If we need to collect guardian's or children's personal information beyond the above scope, we will inform
          the guardian again and obtain the guardian's consent.</p>
        <p class="bold">(2) Exceptions to Obtaining Consent</p>
        <p>
          In accordance with relevant laws and regulations, in the following circumstances, collecting children's
          information does not require obtaining authorization or consent from the child and/or the guardian:
        </p>
        <p>(1) Related to national security, national defense security, public security, public health, or major public
          interests;</p>
        <p>(2) Related to criminal investigation, prosecution, trial, and judgment execution;</p>
        <p>(3) Related to protecting the life, property, or other major lawful rights and interests of the information
          subject or other individuals, but it is difficult to obtain the guardian's own consent;</p>
        <p>(4) The collected information is disclosed to the public by the child or the guardian;</p>
        <p>(5) Collecting information from legally disclosed information sources, such as lawful news reporting and
          government information disclosure channels;</p>
        <p>(6) Necessary for signing a contract at the guardian's request;</p>
        <p>(7) Necessary for maintaining the secure and stable operation of our services, including detecting and
          resolving service failures;</p>
        <p>(8) Information automatically retained and processed by computer information systems, and it is impossible to
          identify that the retained and processed information is children's personal information;</p>
        <p>(9) Necessary for academic research institutions to conduct statistics or academic research based on public
          interests, and when providing the results of academic research or descriptions externally, the information
          contained in the results is de-identified;</p>
        <p>(10) Other circumstances provided by laws and regulations.</p>
        <p class="bold">(3) Notice Regarding Sensitive Personal Information</p>
        <p class="bold">Children's personal information constitutes sensitive personal information. Except where laws
          explicitly provide that the consent of the child and guardian may not be required, before collecting
          children's personal information, we will inform the child and guardian of the specific purpose and necessity,
          as well as the impact on personal rights and interests, and obtain the guardian's separate consent. If the
          guardian does not consent, we will not collect such information.</p>
        <div class="title">II. Circumstances of Sharing, Transferring, or Disclosing Children's Personal Information
        </div>
        <p>We follow the provisions of laws and regulations and strictly limit the circumstances in which children's
          personal information may be shared, transferred, or disclosed:</p>
        <p>1. Under normal circumstances, we will not share children's personal information with third parties. We may
          share children's personal information with third parties only with the guardian's prior consent.</p>
        <p>2. Solely for the purpose of external processing, we may share children's personal information with
          third-party partners (including payment institutions providing payment services, service providers providing
          data statistics and analysis services, and other service providers), so that they can process the above
          information on our behalf in accordance with our instructions, these Guidelines, and relevant confidentiality
          and security policies.</p>
        <p>If we share children's information with the above third parties, we will conduct a security assessment and
          adopt measures such as encryption, anonymization, and de-identification to safeguard the security of
          children's personal information.</p>
        <p>3. Under normal circumstances, we prohibit the external disclosure of children's personal information.
          However, we may disclose children's personal information for the following purposes:</p>
        <p>(1) Comply with applicable laws, regulations, and other relevant provisions;</p>
        <p>(2) Comply with court judgments, rulings, or other legal proceedings;</p>
        <p>(3) Comply with the requirements of relevant government agencies or other legally authorized organizations;
        </p>
        <p>(4) We have reasonable grounds to believe that compliance with applicable laws, regulations, and other
          relevant provisions is necessary;</p>
        <p>(5) Reasonably necessary for performing relevant service agreements or these Guidelines, safeguarding public
          interests, and protecting the personal and property safety or other lawful rights and interests of our
          customers, us, our affiliates, other users, or employees.</p>
        <p>4. As our business continues to develop, we may undergo mergers, acquisitions, asset transfers, or similar
          transactions, and children's information may be transferred as part of such transactions. We will notify
          guardians of the relevant circumstances through push notifications or announcements, conduct security
          assessments, and require the new company or organization holding children's personal information to continue
          to be bound by this Statement; otherwise, we will require such company or organization to re-obtain
          authorization and consent from the guardian.</p>
        <div class="title">IV. Storage and Protection of Children's Personal Information</div>
        <p>1. We will store and protect children's personal information in accordance with the terms of the Privacy
          Policy. We strictly set information access permissions, adopt the principle of least privilege for staff who
          may have access to children's personal information, and take technical measures to record and monitor staff's
          processing of children's personal information to prevent unlawful copying or downloading of children's
          personal information.</p>
        <p>2. After you and the ward terminate the use of our products or services, we will stop collecting and using
          children's personal information, unless otherwise provided by laws, regulations, or regulatory authorities. If
          we cease operations, we will promptly stop collecting children's personal information, notify the cessation of
          operations through individual delivery or announcement, and delete the children's personal information in our
          possession.</p>
        <p>3. To prevent data abuse in our systems and to monitor malware or bad actors from sending illegal content
          within the system via in-app messages or similar means, we use relevant technologies to identify relevant data
          in order to protect children's lawful interests. If our system detects malware, illegal content, or other
          forms of abuse that violate laws, regulations, or policies, we may suspend the relevant account or take other
          appropriate measures.</p>
        <p>4. If guardians wish to learn more, please refer to the section "How We Retain, Store, and Protect
          Information" in the Privacy Policy for detailed information.</p>
        <div class="title">V. Management of Children's Personal Information</div>
        <p>During a child's use of our products or services, we may provide children and their guardians with
          corresponding operation settings depending on the specific product, so that children and their guardians can
          query, copy, correct, supplement, delete, or withdraw the child's relevant personal information. For details,
          please refer to the relevant provisions in the "How to Manage Your Information" section of the Privacy Policy.
          You may also contact us for assistance.</p>
        <div class="title">VI. Contact Us</div>
        <p>If you have any questions, comments, or suggestions regarding these Guidelines or matters related to the
          personal information of you and the child under your guardianship, please contact our children's personal
          information protection officer through in-app customer service or the following methods. We will review the
          issues involved as soon as possible and respond within no more than fifteen working days or the period
          prescribed by laws and regulations.</p>
        <p>• Send mail to the following address:</p>
        <p>Company Name: Fuzhou Yueciyuan Network Technology Co., Ltd.</p>
        <p>Address: Room 302, 3rd Floor, Building 1#, Fuzhou Shengxin Zhongchuang Network Technology Co., Ltd.
          Renovation Project, Cangshan Park, Pushang Area, Jinshan Industrial Concentration Zone, No. 44 Baihuazhou
          Road, Jianxin Town, Cangshan District, Fuzhou City, Fujian Province, China</p>
        <p>• Send email to the following email address:</p>
        <p>Email: service@joltrixtech.com</p>
      </section>
      <section v-else class="content">
        <div class="head">儿童个人信息保护指引</div>
        <p class="bold">更新日期：2026年09月01日</p>
        <p class="bold">
          儿童监护人特别说明：如果您是儿童用户的监护人，请您仔细阅读和选择是否同意本指引。我们希望请您与我们共同保护儿童的个人信息，教育引导儿童增强个人信息保护意识和能力，指导、提醒和要求他们在未经您同意的情况下，不向任何网络产品和服务提供者提供任何个人信息。
        </p>
        <p class="bold">儿童特别说明：如果您是14周岁以下的未成年人，您需要和您的监护人一起仔细阅读本指引，并在征得您的监护人同意后，使用我们的产品、服务或向我们提供信息。</p>
        <div class="title">一、我们如何收集和使用儿童个人信息</div>
        <p class="bold">（一）我们会严格遵守法律法规的规定以及与用户的约定，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后收集和使用儿童个人信息：</p>
        <p> 1、根据法律及监管要求，当您使用我们的游戏产品（如可露优世界）时，我们需要用户填写<strong>姓名和有效身份证件信息</strong>进行实名认证，如果认证为儿童，我们将按照法律法规的规定进行个人信息的处理。
        </p>
        <p>
          2、当我们识别出用户为儿童时，我们会收集监护人的联系方式（<strong>手机号、电子邮箱</strong>）以及其他有助我们判断监护关系的信息，以验证监护人与儿童的监护关系，来帮助监护人管理和了解儿童使用产品或服务的情况。
        </p>
        <p class="bold">3、在儿童使用产品或服务过程中，我们还会收集其他相关信息，具体请查阅《隐私政策》中“我们如何收集和使用您的个人信息”一节，详细了解我们收集的其他儿童个人信息。</p>
        <p>4、如我们需要超出上述收集范围收集监护人或儿童个人信息，我们将再次告知监护人，并征得监护人的同意。</p>
        <p class="bold">（二）征得授权同意的例外</p>
        <p>根据相关法律法规规定，以下情形中收集儿童的信息无需征得儿童和/或监护人的授权同意：</p>
        <p>（1）与国家安全、国防安全、公共安全、公共卫生、重大公共利益有关的；</p>
        <p>（2）与犯罪侦查、起诉、审判和判决执行有关的；</p>
        <p>（3）出于维护信息主体或其他个人的生命、财产重大合法权益但又很难得到监护人本人同意的；</p>
        <p>（4）所收集的信息是儿童或监护人自行向社会公众公开的；</p>
        <p>（5）从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开渠道；</p>
        <p>（6）根据监护人的要求签订合同所必需的；</p>
        <p>（7）用于维护我们的服务的安全稳定运行所必需的，包括发现、处置服务的故障；</p>
        <p>（8）通过计算机信息系统自动留存处理信息且无法识别所留存处理的信息属于儿童个人信息的；</p>
        <p>（9）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；</p>
        <p>（10）法律法规规定的其他情形。</p>
        <p class="bold">（三）有关敏感个人信息的提示</p>
        <p>
          <strong>儿童的个人信息属于敏感个人信息。</strong>除了法律有明确规定可以不征求儿童和监护人的同意之外，在收集儿童个人信息前，我们会告知儿童及监护人明确的目的和必要性，以及对个人权益的影响，并征得监护人的单独同意，若监护人不同意，则我们不会进行收集。
        </p>
        <div class="title">二、共享、转移、披露儿童个人信息的情形</div>
        <p>我们遵照法律法规的规定，严格限制共享、转移、披露儿童个人信息的情形：</p>
        <p>1、一般情况下，我们不会向第三方分享儿童的个人信息。我们仅在监护人事先同意的情况下，才可能与第三方分享儿童的个人信息。</p>
        <p class="bold">
          2、仅为实现外部处理的目的，我们可能会与第三方合作伙伴（包括提供支付服务的支付机构、提供数据统计和分析服务的服务供应商和其他服务商）分享儿童的个人信息，让他们按照我们的说明、本指引以及相关的保密和安全政策来为我们处理上述信息。
        </p>
        <p>如我们与上述第三方分享儿童的信息，我们将进行安全评估并采用加密、匿名化、去标识化处理等手段保障儿童的个人信息安全。</p>
        <p>3、一般情况下，我们禁止对外披露儿童个人信息，但我们可能基于以下目的披露儿童的个人信息：</p>
        <p>（1）遵守适用的法律法规等有关规定；</p>
        <p>（2）遵守法院判决、裁定或其他法律程序的规定；</p>
        <p>（3）遵守相关政府机关或其他法定授权组织的要求；</p>
        <p>（4）我们有理由确信需要遵守法律法规等有关规定；</p>
        <p>（5）为执行相关服务协议或本指引、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益合理且必要的用途。</p>
        <p>
          4、随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，而儿童的信息有可能作为此类交易的一部分而被转移。我们将通过推送通知、公告形式告知监护人相关情形，并进行安全评估，要求新的持有儿童个人信息的公司、组织继续受本声明的约束，否则，我们将要求该公司、组织重新向监护人征求授权同意。
        </p>
        <div class="title">四、存储和保护儿童个人信息</div>
        <p>
          1、我们会按照《隐私政策》的约定存储与保护儿童个人信息。我们严格设定信息访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。
        </p>
        <p>
          2、在您及被监护人终止使用我们的产品或服务后，我们会停止对儿童个人信息的收集和使用，法律法规或监管部门另有规定的除外。如我们停止运营，我们将及时停止收集儿童个人信息的活动，将停止运营的通知以逐一送达或公告的形式进行通知，并对所持有的儿童个人信息进行删除。
        </p>
        <p>
          3、为了预防系统中的数据滥用行为、监测恶意软件或不法人员通过站内信等方式在系统内发送非法内容，我们会使用相关技术来识别相关数据，以保护儿童合法利益。如果我们的系统检测到违反法律法规或者政策规范的恶意软件、非法内容或其他形式的滥用行为，我们可能会停用相关账号或采取其他适当措施。
        </p>
        <p>4、如监护人希望了解更多，请查阅《隐私政策》“我们如何保留、存储和保护信息”章节进行详细了解。</p>
        <div class="title">五、管理儿童个人信息</div>
        <p>
          在儿童使用我们产品或服务期间，我们可能会视产品具体情况为儿童及其监护人提供相应的操作设置，以便儿童及其监护人可以查询、复制、更正、补充、删除或撤回儿童的相关个人信息，有关详情请参见《隐私政策》“如何管理您的信息”相关规定，您也可以联系我们处理。
        </p>
        <div class="title">六、联系我们</div>
        <p>如您对本指引、您及您监护的儿童个人信息的相关事宜有任何问题、意见或建议，请通过产品内客服或以下方式与我们的儿童个人信息保护专员联系。我们将尽快审核所涉问题，最长在不超过十五个工作日或法律法规规定期限内予以回复。</p>
        <p>•邮寄信件到以下地址：</p>
        <p>公司名称：福州市跃次元网络科技有限公司</p>
        <p>地址：福建省福州市仓山区建新镇百花洲路44号金山工业集中区浦上片仓山园福州圣信众创网络科技有限公司提升改造项目1#楼3层302</p>
        <p>•发送邮件到以下邮箱：</p>
        <p>邮箱：service@joltrixtech.com</p>
      </section>
    </div>
  </section>
</template>

<script setup lang="ts">
const { isOverseas } = useAppState()
const meta = isOverseas.value ? {
  title: 'Kalliu World (Game World)',
  description: 'Kalliu World (Game World) Official Website Create your own world freely. Explore the latest product features, game downloads, version updates, news, announcements, and more.',
  ogTitle: 'Kalliu World (Game World) Start your journey of limitless creativity.',
  ogDescription: 'Kalliu World (Game World) Download the game and explore the latest version updates and official news.'
} : {
  title: '跃次元 - 可露优世界',
  description: '可露优世界 （创意世界）官网，自由创造属于你的世界，获取产品特色、下载与版本动态、新闻公告等最新资讯',
  ogTitle: '可露优世界 （创意世界），开启自由创造之旅',
  ogDescription: '可露优世界 （创意世界），下载游戏，查看版本更新与官方资讯'
}
useSeoMeta(meta)
const route = useRoute()
const { t } = useI18n();
const tabActive = ref<string>(route.query.type as string || 'copyright')
watch(route, () => {
  tabActive.value = route.query.type as string
}, { deep: true })
</script>

<style lang="less" scoped>
.legal {
  background-image: url('../assets/images/detail/bg.png');
  background-size: cover;
  background-position-y: -600px;
  padding-top: 337px;
  padding-bottom: 132px;

  .tab {
    display: flex;
    flex-wrap: wrap;
    padding: 0 29px;
    box-sizing: border-box;
    width: 100%;

    div {
      max-width: 100%;
      min-width: 282px;
      flex-shrink: 0;
      padding: 17px;
      box-sizing: border-box;
      min-height: 86px;
      border-radius: 39px;
      border: 3px solid #979797;
      backdrop-filter: blur(6.7px);
      -webkit-backdrop-filter: blur(6.7px);
      font-weight: bold;
      font-size: 35px;
      color: #000000;
      text-align: left;
      margin: 10px 23px 10px 0;
      cursor: pointer;
      word-break: break-all;
    }

    .active {
      background: #D777FF;
      color: #fff;
      border-color: #D777FF;
    }
  }



  .content {
    width: 1022px;
    max-height: 1155px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 63px;
    border: 6px solid #FFFFFF;
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    margin: 46px auto 0;
    padding: 66px 32px 40px 37px;
    box-sizing: border-box;
    overflow: auto;

    .link {
      color: #1677ff;
      text-decoration: underline;
      cursor: pointer;
    }

    .head {
      font-weight: bold;
      font-size: 43px;
      color: #000000;
      line-height: 66px;
      text-align: center;
      margin-bottom: 30px;
    }

    .title {
      font-weight: bold;
      font-size: 40px;
      color: #000000;
      line-height: 80px;
      margin-top: 40px;
    }

    p {
      font-weight: 400;
      font-size: 37px;
      color: #000000;
      line-height: 58px;
    }

    .bold {
      font-weight: bold;
    }
  }
}

@media only screen and (min-width: 768px) {
  .legal {
    flex: 1;
    background-image: url('../assets/images/detail/bg-pc.png');
    background-size: cover;
    background-position-y: -200px;
    padding-top: 75px;
    padding-bottom: 51px;

    .tab {
      width: 764px;
      margin: 0 auto;
      padding: 0;

      div {
        min-width: 87px;
        min-height: 23px;
        flex-shrink: 1;
        padding: 0 0;
        height: 23px;
        border-radius: 14px;
        border: 1px solid #979797;
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        font-size: 10px;
        line-height: 23px;
        margin-right: 10px;
        padding: 0 10px;
      }
    }

    .content {
      width: 766px;
      height: 387px;
      border-radius: 23px;
      border: 2px solid #FFFFFF;
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      padding: 25px 12px 22px 12px;
      margin-top: 17px;

      .head {
        font-size: 11px;
        line-height: 17px;
        margin-bottom: 10px;
      }

      .bold {
        font-weight: bold;
        line-height: 15px;
      }

      p {
        font-size: 9px;
        color: #373D3E;
        line-height: 13px;
      }

      .title {
        font-size: 12px;
        color: #000000;
        line-height: 30px;
        margin-top: 10px;
      }
    }
  }
}

.ar {
  .content {
    direction: rtl;
    text-align: right;
  }

  .tab {
    direction: rtl;
    text-align: right;
  }
}
</style>